import { Form } from 'formsy-semantic-ui-react'
import React, { Component } from 'react'
import { Comment, Header, Modal, Button, GridColumn, Grid, Dimmer, Loader, Label, Icon } from 'semantic-ui-react'
import { getRequestNotes, addRequestNotes } from '../../services/Manager';
import './ServiceRequestNotesModal.less'
import moment from 'moment';
import DGTextarea from 'components/FormControls/Textarea/DGTextarea';
import close from '../../assets/images/newui/close.png'
import Draggable, { DraggableCore } from 'react-draggable'; // Both at the same time


const initialState = { notes: [], notesCharacterCount: 0, note: '', loading: false  , modalHeight: "0px" , modalWidth: "0px"};

class ServiceRequestNotesModal extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    componentDidUpdate = (prevPros) => {
        if(this.props.open &&  this.props.open != prevPros.open)
        {
            this.setModalHeightAndWidth()
        }
    }

    setModalHeightAndWidth = () => {
        let notesParentContainer = document.getElementsByClassName("request-notes-new");
        if (notesParentContainer.length > 0) {
            notesParentContainer = notesParentContainer[0];
            let elementBoundingObj = notesParentContainer.getBoundingClientRect();
            this.setState({ modalHeight: elementBoundingObj.height, modalWidth: elementBoundingObj.width })
        }
    }

    onNotesChange = (e, data) => {
        this.setState({ notesCharacterCount: data.value.length, note: data.value });
    }

    onNotesAdd = async () => {
        this.setState({ loading: true })
        setTimeout(async () => {
            const res = await addRequestNotes(this.props.singleBuyerRequestID, { text: this.state.note });
            if (res.resStatus == 200) {
                if (this.props.onNotesAdd)
                    this.props.onNotesAdd(true);
                this.resetState();
            }
        }, 400);
    }

    onNotesAddCancel = () => {
        if(this.state.notesCharacterCount == 0)
        {
            // close the modal
            this.modalCloseHandler();
        }else
        {
            this.setState({ notesCharacterCount: 0, note: '' });
        }   
    }

    resetState = () => {
        this.setState({ notesCharacterCount: 0, note: '', loading: false });
    }

    modalCloseHandler = () => {
        this.resetState();
        this.props.onClose(false);
    }

    render() {
        const { notes } = this.state;
        return (
            <>
                {
                    this.props.open ?
                        <Draggable handle={"#modal-header-id"}>
                            <div id={"notes-modal-handle"} className="request-notes-modal form-container"
                                style={{ height: this.state.modalHeight + "px", width: this.state.modalWidth + "px" }}>
                                <div id={"modal-header-id"} className={" modal-header heading"}>
                                    {"Add note"}
                                    <Icon className={"close-icon"} name={"close"} onClick={() => { this.modalCloseHandler() }}></Icon>
                                </div>
                                <Form className={"form"} noValidate preventExternalInvalidation>
                                    <div className={"form-content"}>
                                        <div id={"notes-text-area-modal"}>
                                            <DGTextarea name="notes" style={{height:"10px"}}
                                                label="New note" onChange={this.onNotesChange} maxLength={1024} value={this.state.note} required
                                                validationErrors={{
                                                    isDefaultRequiredValue: 'This field is required'
                                                }}
                                            />
                                        </div>
                                        <div className={"button-container"}>
                                            <Button disabled={this.state.loading || this.state.notesCharacterCount == 0} type="button" className="add-note-button-new" content='Save' primary onClick={this.onNotesAdd} />
                                            <Button disabled={this.state.loading 
                                                } type="button" 
                                                className="cancel-add-note-button-new" 
                                                content={this.state.notesCharacterCount == 0 ? "Close" : "Clear"}
                                                onClick={this.onNotesAddCancel} />
                                            <div className="notes-count-new">{this.state.notesCharacterCount}</div>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </Draggable>
                        : ""
                }
            </>
        )
    }
}

export default ServiceRequestNotesModal
